import { VerificationType } from "@amzn/client-workbench-api-model";

import { VerificationStatus } from "@/apis/IdentityCheckHelper";

/**
 * Return the VerificationType that we will be including in the request of getting pre-signed S3 urls based on the
 * NH's current progress.
 * @param verificationStatus The NH's current progress
 */
export const toVerificationType = (
  verificationStatus: VerificationStatus
): VerificationType => {
  switch (verificationStatus) {
    case VerificationStatus.FULL:
      return "ON_BOARDING_FULL_VERIFICATION";
    case VerificationStatus.LIGHT:
      return "ON_BOARDING_LIGHT_VERIFICATION";
    default:
      return "ON_BOARDING_FULL_VERIFICATION";
  }
};
